<template>
  <b-sidebar
    ref="sidebar"
    shadow
    backdrop
    right
    no-close-on-backdrop
    no-close-on-esc
    no-enforce-focus
    bg-variant="white"
    width="420px"
  >
    <template #header>
      <h3 class="my-1 mx-2 font-weight-bolder">
        {{ header }}
      </h3>
    </template>
    <validation-observer
      ref="rules"
      tag="form"
      class="px-3 mt-2"
      @submit.prevent="submit"
    >
      <section v-if="area">
        <b-form-group :label="$t('Management.Areas.Name')" label-for="name">
          <validation-provider
            #default="{ errors }"
            :name="$t('Management.Areas.Name')"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="area.name"
              :placeholder="
                $t('Global.Write', { subject: $t('Management.Areas.Name') })
              "
              :state="errors.length > 0 ? false : null"
              :disabled="!can"
              autocomplete="off"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group
          :label="$t('Management.Areas.Short')"
          label-for="short"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('Management.Areas.Short')"
            rules="required"
          >
            <b-form-input
              id="short"
              v-model="area.short"
              :placeholder="
                $t('Global.Write', {
                  subject: $t('Management.Areas.Short'),
                })
              "
              :state="errors.length > 0 ? false : null"
              :disabled="!can"
              autocomplete="off"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group
          :label="$t('Management.Areas.Country')"
          label-for="country"
        >
          <div class="select-container">
            <div class="country-select">
              <v-select
                id="country"
                v-model="area.country"
                :placeholder="
                  $t('Global.Select', {
                    subject: $t('Management.Areas.Country'),
                  })
                "
                :options="countries"
                :label="label"
                :disabled="!can"
                @option:selected="countrySelected"
              >
              <div slot="no-options">{{ $t("Global.NothingFound") }}</div>
                <template #option="{ name }">
                  <div class="d-flex">
                    {{ name }}
                  </div>
                </template>
                <template #selected-option="{ name }">
                  <div>{{ name }}</div>
                </template>
                
              </v-select>
            </div>
          </div>
        </b-form-group>
      </section>
    </validation-observer>
    <template #footer>
      <div class="d-flex justify-content-between m-2">
        <b-button
          v-if="can"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="submit"
        >
          {{ $t("Global.Save") }}
        </b-button>

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-secondary"
          @click="sidebarVisible = false"
        >
          {{ $t("Global.Retreat") }}
        </b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import vSelect from "vue-select";
import { BButton, BSidebar, BFormInput, BFormGroup } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { preventUnsavedChangesPopupLevel } from "@/utility/mixins/preventUnsavedChanges";

export default {
  components: {
    BButton,
    BSidebar,
    BFormInput,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },

  mixins: [preventUnsavedChangesPopupLevel],

  props: {
    area: {
      type: Object,
      default: () => null,
    },
    countries: {
      type: Array,
      default: () => [],
    },
    can: {
      type: Boolean,
      required: true,
    },
    header: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    required,
    label: "name",
  }),

  methods: {
    countrySelected(selectedOption){
      if(selectedOption.id === "0"){
        this.area.country = null;
        this.$emit("openCountryModal");
      }
    },
    reset() {
      this.$emit("reset");
      this.$refs.rules.reset();
    },
    async submit() {
      const valid = await this.$refs.rules.validate();

      if (valid) {
        this.$emit("submit");
        return;
      }
      this.$alert.invalid();
    },
  },
};
</script>
<style lang="scss">
.select-container {
  position: relative;
  .plus-icon-container {
    position: absolute;
    right: -30px;
    top: 0.5rem;
  }
}
</style>
